import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Button,
  FormControlLabel,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Chip,
  IconButton,
  Tooltip,
  Card,
  CardContent,
  Grid,
  CircularProgress,
} from "@mui/material";
import { ArrowDropDown, DownloadOutlined, Search, Block, CheckCircle, People, PersonAdd, Verified, PendingActions, BuildCircle, HourglassEmpty } from "@mui/icons-material";
import { toast } from "react-toastify";
// import { serverUrl } from '../server';
import { getRequest, patchRequest, server ,postRequest} from "../config";
import moment from "moment";
import PartnerProfile from "../components/PartnerProfile";
import axios from "axios";

// ── Stat Card Component ──────────────────────────────────────────────────────
const StatCard = ({ icon, label, value, color, bg }) => (
  <Card sx={{ flex: 1, minWidth: 160, border: `1.5px solid ${color}30`, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
    <CardContent sx={{ textAlign: "center", py: 2, px: 1.5 }}>
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          backgroundColor: bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 1,
        }}
      >
        <Box sx={{ color }}>{icon}</Box>
      </Box>
      <Typography variant="h5" fontWeight="bold" sx={{ color }}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary" lineHeight={1.3}>
        {label}
      </Typography>
    </CardContent>
  </Card>
);

const PartnerList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [actualValue, setactualValue] = useState({ name: "All Cities" });
  const [partnerPanel, setpartnerPanel] = useState(null);
  const [allCategories, setallCategories] = useState([]);
  const [categoryValue, setcategoryValue] = useState({
    name: "All Categories",
  });
  const [selectedCategory, setselectedCategory] = useState("");
  
  // City-wise stats state
  const [cityStats, setCityStats] = useState({
    totalPartners: 0,
    verifiedPartners: 0,
    unverifiedPartners: 0,
    partnersWithServices: 0,
    partnersWithoutServices: 0,
  });
  const [statsLoading, setStatsLoading] = useState(false);
  
  // Disable/Enable functionality state
  const [disableDialogOpen, setDisableDialogOpen] = useState(false);
  const [enableDialogOpen, setEnableDialogOpen] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [disableReason, setDisableReason] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCustomers();
  }, [searchQuery, page, rowsPerPage, selectedCity, categoryValue]);

  // Fetch city stats whenever city filter changes
  useEffect(() => {
    fetchCityStats(selectedCity);
  }, [selectedCity]);

  // Fetch customers from the LoopBack backend with filter and pagination

  const fetchCities = async () => {
    try {
      const uri = server.uri + "cities";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCities(citiesData);
        setbackData(citiesData);
      }
    } catch (error) {}
  };
  const fetchCategories = async () => {
    try {
      const uri = server.uri + "categories";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCategories(citiesData);
        // setbackData(citiesData);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchCategories();
    fetchCities();
  }, []);

  // ── Fetch City-wise Partner Stats ──────────────────────────────────────────
  const fetchCityStats = async (city) => {
    setStatsLoading(true);
    try {
      // Build base where clause
      const baseWhere = city
        ? `"userType":"partner","city":"${city}"`
        : `"userType":"partner"`;

      // 1. Total partners in city
      const totalRes = await getRequest(
        `${server.uri}users/count?where={${baseWhere}}`
      );
      const total = totalRes?.count || 0;

      // 2. Verified partners
      const verifiedRes = await getRequest(
        `${server.uri}users/count?where={${baseWhere},"status":"verified"}`
      );
      const verified = verifiedRes?.count || 0;

      // Unverified includes every partner who is not verified.
      const unverified = Math.max(0, total - verified);

      // 4. Partners with services & without services
      // Fetch partners with services included to count
      const partnersRes = await getRequest(
        `${server.uri}users?filter={"where":{${baseWhere}},"limit":2000,"include":[{"relation":"services"}]}`
      );
      const partners = Array.isArray(partnersRes) ? partnersRes : partnersRes?.users || [];
      const withServices = partners.filter(
        (p) => p.status === "verified" && p.services && p.services.length > 0
      ).length;
      const withoutServices = partners.filter(
        (p) => p.status === "verified" && (!p.services || p.services.length === 0)
      ).length;

      setCityStats({
        totalPartners: total,
        verifiedPartners: verified,
        unverifiedPartners: unverified,
        partnersWithServices: withServices,
        partnersWithoutServices: withoutServices,
      });
    } catch (error) {
      console.error("Error fetching city stats:", error);
    } finally {
      setStatsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      const exportFilter = {
        where: {
          or: [
            { name: { like: searchQuery } },
            { mobileNumber: { like: searchQuery } },
            { pincode: { like: searchQuery } },
            { uniqueId: searchQuery },
          ],
          userType: "partner",
          ...(selectedCity ? { city: selectedCity } : {}),
        },
        order: "createdAt desc",
        include: [
          {
            relation: "services",
            scope: {
              where:
                categoryValue?.name === "All Categories"
                  ? {}
                  : { categoryId: categoryValue?.categoryId },
            },
          },
        ],
      };
      const endpoint = `${server.uri}users/export?filter=${encodeURIComponent(
        JSON.stringify(exportFilter)
      )}`;
      const response = await axios.get(endpoint, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      // Create a blob link to download
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "partnerList.csv"); // Set filename for download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      alert("Failed to export data.");
    }
  };
  const fetchCustomers = async () => {
    try {
      const filter = {
        where: {
          or: [
            { name: { like: `%${searchQuery}%` } },
            { email: { like: `%${searchQuery}%` } },
            { pincode: { like: `%${searchQuery}%` } },
          ],
        },
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };
      let cityid = "";
      if (selectedCity && selectedCity.length > 0) {
        cityid = `,"city":${selectedCity},`;
        console.log(cityid);
      }
      const category =
        categoryValue.name == "All Categories"
          ? "{}"
          : JSON.stringify({ categoryId: categoryValue?.categoryId });
      if (selectedCity) {
        const response = await getRequest(
          `${server.uri}users?filter={
        "where":{
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}},
         {"pincode":{"like":"${searchQuery}"}},
         {"uniqueId":"${searchQuery}"}
        
      ],"userType":"partner","city":"${selectedCity}"},"skip":"${filter.skip}",
        "limit":"${filter.limit}"
        ,"order":"createdAt desc","include":[{"relation":"services","scope":{"where":${category}}}]}${categoryValue.name == "All Categories" ? "" : `&service=${categoryValue?.categoryId}`}`
        );
        //   console.log(response);

        //
        const responseCount = await getRequest(
          `${server.uri}users/count?where={
        
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}},
         {"mobileNumber":{"like":"${searchQuery}"}},
           {"uniqueId":"${searchQuery}"}
      ],"userType":"partner","city":"${selectedCity}"}`
        );

        console.log(responseCount);

        if (categoryValue.name != "All Categories") {
          setCustomers(response?.users);
          setTotalCount(response?.count);
        } else {
          setTotalCount(responseCount.count);
          setCustomers(response);
        }
      } else {
        const response = await getRequest(
          `${server.uri}users?filter={
            "where":{
            "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}},
             {"pincode":{"like":"${searchQuery}"}},
               {"uniqueId":"${searchQuery}"}
            
          ],"userType":"partner"},"skip":"${filter.skip}",
            "limit":"${filter.limit}"
            ,"order":"createdAt desc","include":[{"relation":"services","scope":{"where":${category}}}]}${categoryValue.name == "All Categories" ? "" : `&service=${categoryValue?.categoryId}`}`
        );
        //   console.log(response);

        const responseCount = await getRequest(
          `${server.uri}users/count?where={
            
            "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}},
             {"pincode":{"like":"${searchQuery}"}},
              {"uniqueId":"${searchQuery}"}
          ],"userType":"partner"}`
        );
        if (categoryValue.name != "All Categories") {
          setCustomers(response?.users);
          setTotalCount(response?.count);
        } else {
          setTotalCount(responseCount.count);
          setCustomers(response);
        }
        console.log(responseCount);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleCityChange = (event, value) => {
    setSelectedCity(value?.name);
    setactualValue(value);
    setPage(0); // Reset to the first page when city changes
  };
  const handleCategorySelect = (event, value) => {
    setselectedCategory(value?.name);
    setcategoryValue(value);
    setPage(0); // Reset to the first page when city changes
  };

  // Disable/Enable Partner Functions
  const handleDisablePartner = (partner) => {
    setSelectedPartner(partner);
    setDisableDialogOpen(true);
    setDisableReason("");
  };

  const handleEnablePartner = (partner) => {
    setSelectedPartner(partner);
    setEnableDialogOpen(true);
  };

  const confirmDisablePartner = async () => {
    if (!disableReason.trim()) {
      toast.error("Please provide a reason for disabling the partner");
      return;
    }

    setLoading(true);
    try {
      const response = await postRequest(`${server.uri}users/${selectedPartner.userId}/disable`, {
        reason: disableReason
      });

      if (response && response.statusCode === 200) {
        toast.success("Partner disabled successfully");
        setDisableDialogOpen(false);
        setDisableReason("");
        setSelectedPartner(null);
        // Refresh the list
        fetchCustomers();
      } else {
        toast.error(response?.message || "Failed to disable partner");
      }
    } catch (error) {
      console.error("Disable Partner Error:", error);
      toast.error("Failed to disable partner. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const confirmEnablePartner = async () => {
    setLoading(true);
    try {
      const response = await postRequest(`${server.uri}users/${selectedPartner.userId}/enable`, {});

      if (response && response.statusCode === 200) {
        toast.success("Partner enabled successfully");
        setEnableDialogOpen(false);
        setSelectedPartner(null);
        // Refresh the list
        fetchCustomers();
      } else {
        toast.error(response?.message || "Failed to enable partner");
      }
    } catch (error) {
      console.error("Enable Partner Error:", error);
      toast.error("Failed to enable partner. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"]; // Example city list
  if (partnerPanel) {
    return (
      <PartnerProfile
        partner={partnerPanel}
        onClose={() => setpartnerPanel(null)}
      />
    );
  }
  return (
    <Container>
      <div
        style={{ marginTop: "50px", marginBottom: "20px" }}
        className="flex items-center justify-between"
      >
        <Typography variant="h4">Partner List</Typography>
        <Button onClick={handleExport} variant="contained">
          <DownloadOutlined /> Export To CSV
        </Button>
      </div>

      {/* Search Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        {/* Search Bar */}
        <TextField
          variant="outlined"
          placeholder="Search by name/mobile number/pincode"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        />
        <FormControl variant="outlined" sx={{ minWidth: 200, mr: 2 }}>
          {/* <InputLabel>City</InputLabel> */}
          <Autocomplete
            value={categoryValue}
            onChange={handleCategorySelect}
            // label="City"
            getOptionLabel={(option) => option?.name}
            options={allCategories}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search Category"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>

        {/* City Dropdown */}
        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
          {/* <InputLabel>City</InputLabel> */}
          <Autocomplete
            value={actualValue}
            onChange={handleCityChange}
            // label="City"
            getOptionLabel={(option) => option?.name}
            options={allCities}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search City"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>
      </Box>

      {/* ── City-wise Partner Stats Section ─────────────────────────────────── */}
      <Paper elevation={1} sx={{ p: 2.5, mb: 3, backgroundColor: "#fafbff" }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h6" fontWeight="bold" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <People color="primary" />
            City Partner Statistics
            {selectedCity && (
              <Chip
                label={selectedCity}
                size="small"
                color="primary"
                variant="outlined"
                sx={{ ml: 1 }}
              />
            )}
            {!selectedCity && (
              <Chip
                label="All Cities"
                size="small"
                color="default"
                variant="outlined"
                sx={{ ml: 1 }}
              />
            )}
          </Typography>
          {statsLoading && <CircularProgress size={20} />}
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard
              icon={<People />}
              label="Total Partners"
              value={cityStats.totalPartners}
              color="#1565c0"
              bg="#e3f2fd"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard
              icon={<Verified />}
              label="Verified Partners"
              value={cityStats.verifiedPartners}
              color="#2e7d32"
              bg="#e8f5e9"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard
              icon={<PendingActions />}
              label="Unverified Partners"
              value={cityStats.unverifiedPartners}
              color="#e65100"
              bg="#fff3e0"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard
              icon={<BuildCircle />}
              label="With Services"
              value={cityStats.partnersWithServices}
              color="#6a1b9a"
              bg="#f3e5f5"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard
              icon={<HourglassEmpty />}
              label="Service Pending"
              value={cityStats.partnersWithoutServices}
              color="#c62828"
              bg="#ffebee"
            />
          </Grid>
        </Grid>
      </Paper>

      <Typography variant="subtitle1" sx={{ textAlign: "right" }} gutterBottom>
        Total Partners: <strong>{totalCount}</strong>
      </Typography>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
                <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell onClick={() => {}} sx={{ fontWeight: "bold" }}>
                  Name
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Services</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Pincode</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>isAvailable</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Disabled</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers?.map((customer) => (
                <TableRow
                  sx={{
                    "&:nth-of-type(even)": {
                      backgroundColor: "#f9fafb", // Alternate row color for better readability
                    },
                  }}
                  key={customer.userId}
                >
                  <TableCell>{customer?.uniqueId}</TableCell>
                  <TableCell
                    onClick={() => setpartnerPanel(customer)}
                    sx={{ cursor: "pointer" }}
                  >
                    {customer?.name}
                  </TableCell>
                  <TableCell>
                    {customer?.services?.map((item) => {
                      return <>{item?.name},</>;
                    })}
                  </TableCell>
                  <TableCell>{customer?.mobileNumber}</TableCell>
                  <TableCell>{customer?.city}</TableCell>
                  <TableCell>{customer?.pincode}</TableCell>
                  <TableCell>{customer?.status}</TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={customer?.isUserActive}
                          disabled
                          onChange={() => {}}
                        />
                      }
                    />
                  </TableCell>
                  <TableCell>
                    {customer?.isDisabled ? (
                      <Chip 
                        label="Disabled" 
                        color="error" 
                        size="small"
                        icon={<Block />}
                      />
                    ) : (
                      <Chip 
                        label="Active" 
                        color="success" 
                        size="small"
                        icon={<CheckCircle />}
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    {customer?.isDisabled ? (
                      <Tooltip title="Enable Partner">
                        <IconButton 
                          color="success" 
                          onClick={() => handleEnablePartner(customer)}
                          disabled={loading}
                        >
                          <CheckCircle />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Disable Partner">
                        <IconButton 
                          color="error" 
                          onClick={() => handleDisablePartner(customer)}
                          disabled={loading}
                        >
                          <Block />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 500, 1000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Disable Partner Dialog */}
      <Dialog
        open={disableDialogOpen}
        onClose={() => setDisableDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Disable Partner</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to disable {selectedPartner?.name}? Please provide a reason for disabling this partner.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Reason for disabling"
            type="text"
            fullWidth
            variant="outlined"
            value={disableReason}
            onChange={(e) => setDisableReason(e.target.value)}
            multiline
            rows={3}
            required
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDisableDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button 
            onClick={confirmDisablePartner} 
            color="error" 
            variant="contained"
            disabled={loading}
          >
            {loading ? "Disabling..." : "Disable Partner"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Enable Partner Dialog */}
      <Dialog
        open={enableDialogOpen}
        onClose={() => setEnableDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Enable Partner</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to enable {selectedPartner?.name}? This will reactivate their account.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEnableDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button 
            onClick={confirmEnablePartner} 
            color="success" 
            variant="contained"
            disabled={loading}
          >
            {loading ? "Enabling..." : "Enable Partner"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default PartnerList;